// extracted by mini-css-extract-plugin
export default {"Badge":"Badge_Badge__EFW1s"};